<template>
  <van-dialog v-model="isShow" confirmButtonText="知道了" v-on="$listeners">
    <div id="submitted-dialog">
      <div class="title">
        <template v-if="isBaseData">
          <p>使用本功能需要资料通过审核。</p>
          <p>您的资料已提交，请等待后台审核。</p>
        </template>
        <template v-else>
          <p>使用本功能需要通过实名认证</p>
          <p>您的认证已提交，请等待后台审核</p>
        </template>
      </div>
      <p class="tips">{{wxId}}</p>
      <img src="/static/img/wechat-person.jpeg" alt="豆子姐微信" class="code" />
      <p class="effect">长按添加管理员微信加速审核</p>
      <p class="effect" ref="code-con">（已复制您的ID信息，请粘贴至微信验证框）</p>
      <strong class="effect">已有豆子姐其他微信者不必重复添加</strong>
    </div>
  </van-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { copy } from '@/utils/tools'

export default {
  name: 'AccelerateAduit',
  data () {
    return {
    }
  },
  model: {
    prop: 'isShowDialog',
    event: 'close'
  },
  props: {
    isShowDialog: Boolean,
    isBaseData: {
      type: Boolean,
      default: true
    },
    wxId: {
      type: String,
      default: '豆子姐微信：sq221356'
    },
    infoData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    isShowDialog (val) {
      if (val) {
        let txt = ''
        // 88818广州-硕士在读清华  或者  88818广州-腾讯开发-硕士清华
        let d = null
        if (this.infoData.nickName) {
          d = this.infoData
          this.execCopy(d)
        } else if (this.userData.nickName) {
          d = this.userData
          this.execCopy(d)
        } else {
          this.$http('/api/member/getMemberPending', {}, 'get').then(res => {
            if (res.code === '0000') {
              this.execCopy(res.data)
            }
          }).catch(err => {})
        }
      }
    }
  },
  computed: {
    ...mapState({
      userData: 'userData',
      educationMap: 'educationMap',
      areaData: 'areaData'
    }),
    ...mapGetters({
      mId: 'mId'
    }),
    isShow: {
      get () {
        return this.isShowDialog
      },
      set () {
        this.$emit('close', false)
      }
    }
  },
  methods: {
    execCopy (d) {
      copy(`${this.mId}${d.cityId == '900000' ? d.state : this.areaData['city_list'][d.cityId]}${d.ifStudent ? '' : `-${d.company + d.job}`}-${this.educationMap[d.education]}${d.ifStudent ? '在读' : ''}${d.school}`,
          this.$refs['code-con']).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
#submitted-dialog {
  text-align: center;
  .title {
    margin-bottom: 20px;
    padding: 24px 0;
    color: #38383c;
    font-size: 32px;
    line-height: 44px;
  }
  .tips {
    font-size: 24px;
    line-height: 36px;
  }
  .code {
    margin: 10px auto 30px;
    width: 260px;
    height: 260px;
  }
  .effect {
    margin-bottom: 4px;
    color: #9b9ba1;
    font-size: 24px;
    line-height: 36px;
  }
}
</style>
